module.exports = __webpack_public_path__ + "img/contacts.7286bcb0.svg";